import { render, staticRenderFns } from "./DiscountPolicyTab.vue?vue&type=template&id=90307270&scoped=true&"
import script from "./DiscountPolicyTab.vue?vue&type=script&lang=js&"
export * from "./DiscountPolicyTab.vue?vue&type=script&lang=js&"
import style0 from "./DiscountPolicyTab.vue?vue&type=style&index=0&id=90307270&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90307270",
  null
  
)

export default component.exports